import { motion } from 'framer-motion';
import { PROCESS, VIDEOS } from '@/content/site';

const ease = [0.16, 1, 0.3, 1];

export default function Process() {
  return (
    <section id="process" className="py-28 lg:py-36 bg-[hsl(var(--cream-2))]/70 border-y border-[hsl(var(--hairline))]/70">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-20">
          {/* Sticky image */}
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-32">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-80px' }}
                transition={{ duration: 0.9, ease }}
              >
                <div className="text-overline mb-7">What to Expect</div>
                <h2 className="font-display text-[1.75rem] sm:text-3xl lg:text-[2.5rem] leading-[1.15]">
                  What happens during a
                  <span className="italic text-[hsl(var(--primary))] font-medium"> lash lift at Prép?</span>
                </h2>
                <p className="mt-7 text-[hsl(var(--muted-foreground))] leading-[1.8]">
                  Every appointment is unhurried, intentional, and tailored to your lashes.
                  Here&apos;s exactly what to expect from your 75 minutes with us.
                </p>
              </motion.div>
              <div className="mt-12 rounded-[1.5rem] overflow-hidden border border-[hsl(var(--hairline))] bg-[hsl(var(--secondary))] luxe-shadow">
                <video
                  src={VIDEOS.gallery[2].src}
                  poster={VIDEOS.gallery[2].poster}
                  autoPlay
                  muted
                  loop
                  playsInline
                  preload="metadata"
                  className="w-full h-[300px] lg:h-[420px] object-cover"
                  data-testid="process-video"
                />
              </div>
            </div>
          </div>

          {/* Steps */}
          <div className="lg:col-span-7">
            <ol className="space-y-12 lg:space-y-14">
              {PROCESS.map((step, i) => (
                <motion.li
                  key={step.n}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: '-80px' }}
                  transition={{ duration: 0.85, ease, delay: i * 0.06 }}
                  className="grid grid-cols-[auto_1fr] gap-6 lg:gap-10 pb-12 lg:pb-14 border-b border-[hsl(var(--hairline))] last:border-b-0 last:pb-0"
                >
                  <div className="font-display text-4xl lg:text-[3.5rem] text-[hsl(var(--primary))] leading-none tracking-tight italic font-light tabular">
                    {step.n}
                  </div>
                  <div>
                    <div className="flex flex-wrap items-baseline gap-x-4 gap-y-1">
                      <h3 className="font-display text-[1.7rem] lg:text-[2rem] tracking-tight">
                        {step.title}
                      </h3>
                      <span className="text-[0.62rem] uppercase tracking-[0.32em] text-[hsl(var(--muted-foreground))] font-light">
                        {step.time}
                      </span>
                    </div>
                    <p className="mt-4 text-[hsl(var(--muted-foreground))] leading-[1.8]">
                      {step.body}
                    </p>
                  </div>
                </motion.li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}
